const ONBOARDING_DATA_KEY = 'onboarding_data'
const ONBOARDING_ROLE_ID_KEY = 'onboarding_role_id'

const setOnboardingSession = ({ data, roleId }) => {
	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		throw new Error('ข้อมูล onboarding จาก SSO ไม่ถูกต้อง')
	}

	if (!Number.isInteger(roleId)) {
		throw new Error('ไม่พบประเภทผู้ใช้สำหรับ onboarding')
	}

	sessionStorage.setItem(ONBOARDING_DATA_KEY, JSON.stringify(data))
	sessionStorage.setItem(ONBOARDING_ROLE_ID_KEY, String(roleId))
}

const getOnboardingSession = () => {
	try {
		const rawData = sessionStorage.getItem(ONBOARDING_DATA_KEY)
		const rawRoleId = sessionStorage.getItem(ONBOARDING_ROLE_ID_KEY)
		if (!rawData || !rawRoleId) return null

		const data = JSON.parse(rawData)
		const roleId = Number(rawRoleId)
		if (!data || typeof data !== 'object' || Array.isArray(data) || !Number.isInteger(roleId)) {
			return null
		}

		return { data, roleId }
	} catch (_error) {
		return null
	}
}

const clearOnboardingSession = () => {
	sessionStorage.removeItem(ONBOARDING_DATA_KEY)
	sessionStorage.removeItem(ONBOARDING_ROLE_ID_KEY)
}

export {
	clearOnboardingSession,
	getOnboardingSession,
	setOnboardingSession,
}
